export const data = [
    {
        text: "This is my personal portfolio website",
        title: "simon aust's portfolio",
        image: "./resources/link-imgs/simon-aust-porfolio-low.jpg",
        link: "https://www.simonaust.co.uk",
        type: "personal",
    },
    {
        text: "A handy website to generate a wavey path for an SVG. As seen at the top of this website",
        title: "SVG wave generator",
        image: "./resources/link-imgs/wave-generator-low.jpg",
        link: "https://smooth.ie/blogs/news/svg-wavey-transitions-between-sections",
        type: "tool",
    },
    {
        text: "Create much more exciting border radii",
        title: "Fancy Border Radius Generator",
        image: "./resources/link-imgs/fancy-border-radius-low.jpg",
        link: "https://9elements.github.io/fancy-border-radius/#41.50.25.39--.",
        type: "tool",
    },
    {
        text: "Design clip-paths with this visual tool",
        title: "Clippy - CSS clip-path maker",
        image: "./resources/link-imgs/clip-path-low.jpg",
        link: "https://bennettfeely.com/clippy/",
        type: "tool",
    },
    {
        text: "A encylopedia of emojis",
        title: "Unicode 10.0 Emoji List",
        image: "./resources/link-imgs/emoji-pedia.jpg",
        link: "https://emojipedia.org/unicode-10.0/",
        type: "tool",
    },
];
